import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useAllProfessions = () => {
  const { data: allProfessions = [], isLoading, refetch } = useQuery({
    queryKey: ['allProfessions'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('professions')
        .select('name')
        .order('name', { ascending: true });
      
      if (error) {
        console.error('Error fetching all professions:', error);
        throw error;
      }
      
      return data?.map((item: any) => item.name) || [];
    },
    staleTime: 60 * 60 * 1000, // 1 hora (dados raramente mudam)
    refetchOnWindowFocus: false,
  });

  return {
    allProfessions,
    isLoading,
    refetch
  };
};


